export default "images/红绿灯提示.png";